<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_ii"></a>Also by Bob Shacochis</p>
<p class="noindents"><span class="small">EASY IN THE ISLANDS<br/>THE NEXT NEW WORLD<br/>DOMESTICITY<br/>THE IMMACULATE INVASION</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// otherfm1.vue?e8d5aace